import constants from '@/constants';
import emrTypeHelper from '@/helper/emrType';
import ViewChart from '@/screens/Timeline/components/ViewChart';
import ViewDefault from '@/screens/Timeline/components/ViewDefault';
import ViewTable from '@/screens/Timeline/components/ViewTable';
import { IQuickModalResult } from '@/utils/quickModal';
import dayjs from 'dayjs';
import * as React from 'react';

export interface IDetailContentProps {
  emr: IEMRData;
  emrType: IEMRType;
  disabled?: boolean;
  onOK?: (_: IQuickModalResult) => void;
  onCancel?: (_: IQuickModalResult) => void;
}

const DetailContent: React.FC<IDetailContentProps> = ({ emr, emrType, onOK, onCancel, ...props }) => {
  switch (emrType?.extra?.formDetail?.type) {
    case 'table':
      return (
        <div className="px-4">
          <ViewTable emrType={emrType} emr={emr} />
        </div>
      );

    case 'tableAndChart':
      return (
        <div className="px-4 pb-4">
          <ViewTable
            emrType={emrType}
            emr={emr}
            extend={(data, pointIndex, _, isFetching, fetchNextPage) => {
              return (
                <div className="mb-2 rounded-lg">
                  <ViewChart
                    loadmore={fetchNextPage}
                    isFetching={isFetching}
                    title={`Biểu đồ ${emrType.name}`}
                    times={data?.map((d: any) => (d.date ? dayjs(d.date).format(constants.DATE_TIME_FORMAT) : null))}
                    pointIndex={pointIndex}
                    series={emrType.extra.formDetail?.chartConfigFn?.(data, emrType, emrTypeHelper.toFixByKeyConfig)}
                  />
                </div>
              );
            }}
          />
        </div>
      );
    case 'tab':
    default:
      return <ViewDefault emr={emr} emrType={emrType} />;
  }
};
export default DetailContent;
